import React from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

import { logOut } from '../../Services/UserAuth/UserAuthenticate';

export default function LogOut({ modalState, toggler }) {
    return (
        
        <Modal isOpen={modalState} toggle={toggler} > 
               <div className='mx-5 mt-5 d-flex item-center' >
                <i className={"fas fa-sign-out-alt mr-2 ml-3 fa-2x text-danger"}></i>
                <span style={{ fontSize: "18px" }}>
                    Are you sure you want to logout?
                </span>
                </div>
            <ModalFooter>
                <Button color="secondary" onClick={toggler}>Cancel</Button>
                <Button
                    color="danger"
                    onClick={logOut}>
                    Log Out
                </Button>
            </ModalFooter>
        </Modal>
    )
}
